import script from "./referralFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./referralFooter.vue?vue&type=script&setup=true&lang=js"

import "./referralFooter.vue?vue&type=style&index=0&id=17b9e73c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17b9e73c"]])

export default __exports__